<template>
	<div style="height: 100%;">
		<div class="demo-split">
			<Split v-model="split1">
				<div slot="left" class="demo-split-pane">
					<Form :model="formInlineP" inline style="text-align: left;margin-top: 1%;">
						<FormItem v-if="priceModal==this.$t('Common.Search')" prop="trackName" :label="this.$t('PriceManagement.TemplateName')" :label-width="100">
							<Select v-model="selectPriceId" placeholder="this.$t('PriceManagement.TemplateList')" style="width: 200px;" @on-change="showPriceModel">
								<Option :key="itemIndex" v-for="(item,itemIndex) in PriceList" :value="item.Id">
									{{item.Name}}
								</Option>
							</Select>
						</FormItem>
						<FormItem v-if="priceModal==this.$t('Common.Add')" prop="Name" :label="this.$t('PriceManagement.NewTemplateName')" :label-width="100">
							<Input type="text" v-model="formInlineP.Name" :placeholder="this.$t('PriceManagement.NewTemplateName')" />
						</FormItem>
						<FormItem v-if="priceModal==this.$t('Common.Add')" style='float: right;'>
							<Button type="primary" @click="handleSubmitP('add')" v-if="hasWidgets('save')">{{ this.$t('Common.Save') }}</Button>
						</FormItem>
						<FormItem v-if="priceModal==this.$t('Common.Search')" style='float: right;'>
							<Button type="primary" @click="handleSubmitP('changeModalAdd')">{{ this.$t('PriceManagement.SwitchAddPrice') }}</Button>
						</FormItem>
						<FormItem v-if="priceModal==this.$t('Common.Add')" style='float: right;'>
							<Button type="primary" @click="handleSubmitP('changeModalSelect')">{{ this.$t('PriceManagement.SwitchQueryPrice') }}</Button>
						</FormItem>
						<FormItem v-if="priceModal==$t('PriceManagement.Real-TimePrice')" :label="this.$t('PriceManagement.GunViewingRealTimePrice')" :label-width="150">
							<Input type="text" v-model="currentConn" :placeholder="this.$t('PriceManagement.TemplateName')" />
						</FormItem>
						<FormItem v-if="priceModal==$t('PriceManagement.Real-TimePrice')" style='float: right;'>
							<Button type="error" @click="handleSubmitP('changeModalSelect')">{{ this.$t('PriceManagement.TurnOffViewingRealTimePrice') }}</Button>
						</FormItem>
					</Form>
					<div style="border: 1px solid #d4cfc7;padding: 2px;">
						<Form ref="formInlineP" :model="formInlineP" inline style="text-align: left;margin-top: 1%;">
							<Row style="margin-top: 10px;" v-show="false">
								<Col span=5>
								<FormItem prop="Id" label="Id" :label-width="65">
									<TimeSelect :disabled="ifAddPrice" v-model="formInlineP.Id"></TimeSelect>
									<!-- <TimePicker :disabled="ifAddPrice" v-model="formInlineP.Period1BeginTime" format="HH:mm" :steps="[1,30]"
									 placeholder="Select time"></TimePicker> -->
								</FormItem>
								</Col>
								<Col span=5>
								<FormItem prop="Name" label="Name:" :label-width="65">
									<TimeSelect :disabled="ifAddPrice" v-model="formInlineP.Name"></TimeSelect>
								</FormItem>
								</Col>
							</Row>

							<Row style="margin-top: 10px;">
								<FormItem>
									<Tag color="primary">{{ this.$t('PriceManagement.Period') }}1</Tag>
								</FormItem>
								<FormItem prop="Period1BeginTime" :label="this.$t('Common.Time')" :label-width="40">
									<TimeSelect :disabled="ifAddPrice" v-model="formInlineP.Period1BeginTime" style="width: 70px;" />-
									<TimeSelect :disabled="ifAddPrice" v-model="formInlineP.Period1EndTime" style="width: 70px;" />
								</FormItem>
								<FormItem prop="Period1Price" :label="this.$t('PriceManagement.ElectricityUnitPrice')" :label-width="70">
									<Input :disabled="ifAddPrice" type="text" v-model="formInlineP.Period1Price" :placeholder="this.$t('PriceManagement.ElectricityUnitPrice')"
										style="width: 55px;" />
								</FormItem>
								<FormItem prop="Period1ServicePrice" :label="this.$t('PriceManagement.ServiceFee')" :label-width="70">
									<Input :disabled="ifAddPrice" type="text" v-model="formInlineP.Period1ServicePrice" :placeholder="this.$t('PriceManagement.ServiceFee')"
										style="width: 55px;" />
								</FormItem>
							</Row>
							<Row style="margin-top: 10px;">
								<FormItem>
									<Tag color="primary">{{ this.$t('PriceManagement.Period') }}2</Tag>
								</FormItem>
								<FormItem prop="Period2BeginTime" :label="this.$t('Common.Time')" :label-width="40">
									<TimeSelect :disabled="ifAddPrice" v-model="formInlineP.Period2BeginTime" style="width: 70px;" />-
									<TimeSelect :disabled="ifAddPrice" v-model="formInlineP.Period2EndTime" style="width: 70px;" />
								</FormItem>
								<FormItem prop="Period2Price" :label="this.$t('PriceManagement.ElectricityUnitPrice')" :label-width="70">
									<Input :disabled="ifAddPrice" type="text" v-model="formInlineP.Period2Price" :placeholder="this.$t('PriceManagement.ElectricityUnitPrice')"
										style="width: 55px;" />
								</FormItem>
								<FormItem prop="Period2ServicePrice" :label="this.$t('PriceManagement.ServiceFee')" :label-width="70">
									<Input :disabled="ifAddPrice" type="text" v-model="formInlineP.Period2ServicePrice" :placeholder="this.$t('PriceManagement.ServiceFee')"
										style="width: 55px;" />
								</FormItem>
							</Row>
							<Row style="margin-top: 10px;">
								<FormItem>
									<Tag color="primary">{{ this.$t('PriceManagement.Period') }}3</Tag>
								</FormItem>
								<FormItem prop="Period3BeginTime" :label="this.$t('Common.Time')" :label-width="40">
									<TimeSelect :disabled="ifAddPrice" v-model="formInlineP.Period3BeginTime" style="width: 70px;" />-
									<TimeSelect :disabled="ifAddPrice" v-model="formInlineP.Period3EndTime" style="width: 70px;" />
								</FormItem>
								<FormItem prop="Period3Price" :label="this.$t('PriceManagement.ElectricityUnitPrice')" :label-width="70">
									<Input :disabled="ifAddPrice" type="text" v-model="formInlineP.Period3Price" :placeholder="this.$t('PriceManagement.ElectricityUnitPrice')"
										style="width: 55px;" />
								</FormItem>
								<FormItem prop="Period3ServicePrice" :label="this.$t('PriceManagement.ServiceFee')" :label-width="70">
									<Input :disabled="ifAddPrice" type="text" v-model="formInlineP.Period3ServicePrice" :placeholder="this.$t('PriceManagement.ServiceFee')"
										style="width: 55px;" />
								</FormItem>
							</Row>
							<Row style="margin-top: 10px;">
								<FormItem>
									<Tag color="primary">{{ this.$t('PriceManagement.Period') }}4</Tag>
								</FormItem>
								<FormItem prop="Period4BeginTime" :label="this.$t('Common.Time')" :label-width="40">
									<TimeSelect :disabled="ifAddPrice" v-model="formInlineP.Period4BeginTime" style="width: 70px;" />-
									<TimeSelect :disabled="ifAddPrice" v-model="formInlineP.Period4EndTime" style="width: 70px;" />
								</FormItem>
								<FormItem prop="Period4Price" :label="this.$t('PriceManagement.ElectricityUnitPrice')" :label-width="70">
									<Input :disabled="ifAddPrice" type="text" v-model="formInlineP.Period4Price" :placeholder="this.$t('PriceManagement.ElectricityUnitPrice')"
										style="width: 55px;" />
								</FormItem>
								<FormItem prop="Period4ServicePrice" :label="this.$t('PriceManagement.ServiceFee')" :label-width="70">
									<Input :disabled="ifAddPrice" type="text" v-model="formInlineP.Period4ServicePrice" :placeholder="this.$t('PriceManagement.ServiceFee')"
										style="width: 55px;" />
								</FormItem>
							</Row>
							<Row style="margin-top: 10px;">
								<FormItem>
									<Tag color="primary">{{ this.$t('PriceManagement.Period') }}5</Tag>
								</FormItem>
								<FormItem prop="Period5BeginTime" :label="this.$t('Common.Time')" :label-width="40">
									<TimeSelect :disabled="ifAddPrice" v-model="formInlineP.Period5BeginTime" style="width: 70px;" />-
									<TimeSelect :disabled="ifAddPrice" v-model="formInlineP.Period5EndTime" style="width: 70px;" />
								</FormItem>
								<FormItem prop="Period5Price" :label="this.$t('PriceManagement.ElectricityUnitPrice')" :label-width="70">
									<Input :disabled="ifAddPrice" type="text" v-model="formInlineP.Period5Price" :placeholder="this.$t('PriceManagement.ElectricityUnitPrice')"
										style="width: 55px;" />
								</FormItem>
								<FormItem prop="Period5ServicePrice" :label="this.$t('PriceManagement.ServiceFee')" :label-width="70">
									<Input :disabled="ifAddPrice" type="text" v-model="formInlineP.Period5ServicePrice" :placeholder="this.$t('PriceManagement.ServiceFee')"
										style="width: 55px;" />
								</FormItem>
							</Row>
							<Row style="margin-top: 10px;">
								<FormItem>
									<Tag color="primary">{{ this.$t('PriceManagement.Period') }}6</Tag>
								</FormItem>
								<FormItem prop="Period6BeginTime" :label="this.$t('Common.Time')" :label-width="40">
									<TimeSelect :disabled="ifAddPrice" v-model="formInlineP.Period6BeginTime" style="width: 70px;" />-
									<TimeSelect :disabled="ifAddPrice" v-model="formInlineP.Period6EndTime" style="width: 70px;" />
								</FormItem>
								<FormItem prop="Period6Price" :label="this.$t('PriceManagement.ElectricityUnitPrice')" :label-width="70">
									<Input :disabled="ifAddPrice" type="text" v-model="formInlineP.Period6Price" :placeholder="this.$t('PriceManagement.ElectricityUnitPrice')"
										style="width: 55px;" />
								</FormItem>
								<FormItem prop="Period6ServicePrice" :label="this.$t('PriceManagement.ServiceFee')" :label-width="70">
									<Input :disabled="ifAddPrice" type="text" v-model="formInlineP.Period6ServicePrice" :placeholder="this.$t('PriceManagement.ServiceFee')"
										style="width: 55px;" />
								</FormItem>
							</Row>
							<Row style="margin-top: 10px;">
								<FormItem>
									<Tag color="primary">{{ this.$t('PriceManagement.Period') }}7</Tag>
								</FormItem>
								<FormItem prop="Period7BeginTime" :label="this.$t('Common.Time')" :label-width="40">
									<TimeSelect :disabled="ifAddPrice" v-model="formInlineP.Period7BeginTime" style="width: 70px;" />-
									<TimeSelect :disabled="ifAddPrice" v-model="formInlineP.Period7EndTime" style="width: 70px;" />
								</FormItem>
								<FormItem prop="Period7Price" :label="this.$t('PriceManagement.ElectricityUnitPrice')" :label-width="70">
									<Input :disabled="ifAddPrice" type="text" v-model="formInlineP.Period7Price" :placeholder="this.$t('PriceManagement.ElectricityUnitPrice')"
										style="width: 55px;" />
								</FormItem>
								<FormItem prop="Period7ServicePrice" :label="this.$t('PriceManagement.ServiceFee')" :label-width="70">
									<Input :disabled="ifAddPrice" type="text" v-model="formInlineP.Period7ServicePrice" :placeholder="this.$t('PriceManagement.ServiceFee')"
										style="width: 55px;" />
								</FormItem>
							</Row>
							<Row style="margin-top: 10px;">
								<FormItem>
									<Tag color="primary">{{ this.$t('PriceManagement.Period') }}8</Tag>
								</FormItem>
								<FormItem prop="Period8BeginTime" :label="this.$t('Common.Time')" :label-width="40">
									<TimeSelect :disabled="ifAddPrice" v-model="formInlineP.Period8BeginTime" style="width: 70px;" />-
									<TimeSelect :disabled="ifAddPrice" v-model="formInlineP.Period8EndTime" style="width: 70px;" />
								</FormItem>
								<FormItem prop="Period8Price" :label="this.$t('PriceManagement.ElectricityUnitPrice')" :label-width="70">
									<Input :disabled="ifAddPrice" type="text" v-model="formInlineP.Period8Price" :placeholder="this.$t('PriceManagement.ElectricityUnitPrice')"
										style="width: 55px;" />
								</FormItem>
								<FormItem prop="Period8ServicePrice" :label="this.$t('PriceManagement.ServiceFee')" :label-width="70">
									<Input :disabled="ifAddPrice" type="text" v-model="formInlineP.Period8ServicePrice" :placeholder="this.$t('PriceManagement.ServiceFee')"
										style="width: 55px;" />
								</FormItem>
							</Row>
							<Row style="margin-top: 10px;">
								<FormItem>
									<Tag color="primary">{{ this.$t('PriceManagement.Period') }}9</Tag>
								</FormItem>
								<FormItem prop="Period9BeginTime" :label="this.$t('Common.Time')" :label-width="40">
									<TimeSelect :disabled="ifAddPrice" v-model="formInlineP.Period9BeginTime" style="width: 70px;" />-
									<TimeSelect :disabled="ifAddPrice" v-model="formInlineP.Period9EndTime" style="width: 70px;" />
								</FormItem>
								<FormItem prop="Period9Price" :label="this.$t('PriceManagement.ElectricityUnitPrice')" :label-width="70">
									<Input :disabled="ifAddPrice" type="text" v-model="formInlineP.Period9Price" :placeholder="this.$t('PriceManagement.ElectricityUnitPrice')"
										style="width: 55px;" />
								</FormItem>
								<FormItem prop="Period9ServicePrice" :label="this.$t('PriceManagement.ServiceFee')" :label-width="70">
									<Input :disabled="ifAddPrice" type="text" v-model="formInlineP.Period9ServicePrice" :placeholder="this.$t('PriceManagement.ServiceFee')"
										style="width: 55px;" />
								</FormItem>
							</Row>
							<Row style="margin-top: 10px;">
								<FormItem>
									<Tag color="primary">{{ this.$t('PriceManagement.Period') }}10</Tag>
								</FormItem>
								<FormItem prop="Period10BeginTime" :label="this.$t('Common.Time')" :label-width="40">
									<TimeSelect :disabled="ifAddPrice" v-model="formInlineP.Period10BeginTime" style="width: 70px;" />-
									<TimeSelect :disabled="ifAddPrice" v-model="formInlineP.Period10EndTime" style="width: 70px;" />
								</FormItem>
								<FormItem prop="Period10Price" :label="this.$t('PriceManagement.ElectricityUnitPrice')" :label-width="70">
									<Input :disabled="ifAddPrice" type="text" v-model="formInlineP.Period10Price" :placeholder="this.$t('PriceManagement.ElectricityUnitPrice')"
										style="width: 55px;" />
								</FormItem>
								<FormItem prop="Period10ServicePrice" :label="this.$t('PriceManagement.ServiceFee')" :label-width="70">
									<Input :disabled="ifAddPrice" type="text" v-model="formInlineP.Period10ServicePrice" :placeholder="this.$t('PriceManagement.ServiceFee')"
										style="width: 55px;" />
								</FormItem>
							</Row>
							<Row style="margin-top: 10px;">
								<FormItem>
									<Tag color="primary">{{ this.$t('PriceManagement.Period') }}11</Tag>
								</FormItem>
								<FormItem prop="Period11BeginTime" :label="this.$t('Common.Time')" :label-width="40">
									<TimeSelect :disabled="ifAddPrice" v-model="formInlineP.Period11BeginTime" style="width: 70px;" />-
									<TimeSelect :disabled="ifAddPrice" v-model="formInlineP.Period11EndTime" style="width: 70px;" />
								</FormItem>
								<FormItem prop="Period11Price" :label="this.$t('PriceManagement.ElectricityUnitPrice')" :label-width="70">
									<Input :disabled="ifAddPrice" type="text" v-model="formInlineP.Period11Price" :placeholder="this.$t('PriceManagement.ElectricityUnitPrice')"
										style="width: 55px;" />
								</FormItem>
								<FormItem prop="Period11ServicePrice" :label="this.$t('PriceManagement.ServiceFee')" :label-width="70">
									<Input :disabled="ifAddPrice" type="text" v-model="formInlineP.Period11ServicePrice" :placeholder="this.$t('PriceManagement.ServiceFee')"
										style="width: 55px;" />
								</FormItem>
							</Row>
							<Row style="margin-top: 10px;">
								<FormItem>
									<Tag color="primary">{{ this.$t('PriceManagement.Period') }}12</Tag>
								</FormItem>
								<FormItem prop="Period12BeginTime" :label="this.$t('Common.Time')" :label-width="40">
									<TimeSelect :disabled="ifAddPrice" v-model="formInlineP.Period12BeginTime" style="width: 70px;" />-
									<TimeSelect :disabled="ifAddPrice" v-model="formInlineP.Period12EndTime" style="width: 70px;" />
								</FormItem>
								<FormItem prop="Period12Price" :label="this.$t('PriceManagement.ElectricityUnitPrice')" :label-width="70">
									<Input :disabled="ifAddPrice" type="text" v-model="formInlineP.Period12Price" :placeholder="this.$t('PriceManagement.ElectricityUnitPrice')"
										style="width: 55px;" />
								</FormItem>
								<FormItem prop="Period12ServicePrice" :label="this.$t('PriceManagement.ServiceFee')" :label-width="70">
									<Input :disabled="ifAddPrice" type="text" v-model="formInlineP.Period12ServicePrice" :placeholder="this.$t('PriceManagement.ServiceFee')"
										style="width: 55px;" />
								</FormItem>
							</Row>
							
						</Form>
					</div>
				</div>
				<div slot="right" class="demo-split-pane">
					<Form ref="formInline" :model="formInline" inline style="text-align: left;margin-top: 1%;">
						<FormItem prop="trackName" :label="this.$t('Station')" :label-width="80">
							<Select :placeholder="this.$t('Station')" style="width: 120px;" v-model="formInline.StationId">
								<Option :value=0>{{ this.$t('Common.All') }}</Option>
								<Option v-bind:key="item.StationId" v-for="(item) in StationList" :value="item.StationId">
									{{item.StationName}}</Option>
							</Select>
						</FormItem>
						
						<FormItem prop="EquipmentNo" :label="this.$t('EquipmentNo')" :label-width="100">
							<Input type="text" v-model="formInline.EquipmentNo" :placeholder="this.$t('EquipmentNo')"  style="width: 120px;"/>
						</FormItem>
						<FormItem :label="this.$t('EquipmentType')" prop="EquipmentType" :label-width="70">
							<Select :placeholder="this.$t('EquipmentType')" v-model="formInline.EquipmentType" style="width: 120px;">
								<Option :value='0'>{{ this.$t('Common.All') }}</Option>
								<Option :value='1'>{{ this.$t('DCCharger') }}</Option>
				                <Option :value='2'>{{ this.$t('ACCharger') }}</Option>
				                <Option :value='3'>{{ this.$t('ACDCIntegrated') }}</Option>
				                <Option :value='4'>{{ this.$t('WirelessCharger') }}</Option>
				                <Option :value='5'>{{ this.$t('Other') }}</Option>
								
							</Select>
						</FormItem>
						<FormItem>
							<Button type="primary" @click="handleSubmit('formInline')" v-if="hasWidgets('search')">{{ $t('Common.Search') }}</Button>
						</FormItem>
						<FormItem style="float: right;" v-if="priceModal==this.$t('Common.Search')">
							<Button type="primary" @click="show('command')" v-if="hasWidgets('setPrice')">{{ this.$t('PriceManagement.SetPrice') }}</Button>
						</FormItem>
					</Form>
					<Table style="width: 100%;" @on-selection-change="selectChange" :columns="columns1" :data="data1"
						:height="tableHeight"></Table>
					<MyPage ref="sonPage" :param="pageParam" :url="getEquipmentListForPriceManageUrl" @listData='getDeviceData'>
					</MyPage>
				</div>
			</Split>
		</div>
	</div>
</template>

<script>
	import dateFormat from '../../../../public/js/comm.js'
	import Qs from 'qs'
	//import expandRow from './StationManagementExpand.vue';
	import {
		mapState,
		mapGetters,
		mapActions
	} from 'vuex'
	import webapi from '../../../webapi.js'
	export default {
		data() {
			return {
				getEquipmentListForPriceManageUrl: webapi.base_api_url + '/Archives/GetEquipmentListForPriceManage',
				//ifQueryPrice: false,
				
				currentConn: '',
				priceModal: this.$t('Common.Add'),
				value: '',
				
				split1: 0.45,
				loadingStatus: false,
			
				params: "", //table 
				tableHeight: "650",
				modal: {
					Title: "Add",
					type: "addStation"
				},
				modalView: false,
		
				ifAddPrice: false,
				selectPriceId: '',
				formInlineP: {
					Id: 0,
					Name: '',
					Period1BeginTime: "00:00",
					Period1EndTime: "00:00",
					Period1Price: "0",
					Period1ServicePrice: "0",

					Period2BeginTime: "00:00",
					Period2EndTime: "00:00",
					Period2Price: "0",
					Period2ServicePrice: "0",

					Period3BeginTime: "00:00",
					Period3EndTime: "00:00",
					Period3Price: "0",
					Period3ServicePrice: "0",

					Period4BeginTime: "00:00",
					Period4EndTime: "00:00",
					Period4Price: "0",
					Period4ServicePrice: "0",

					Period5BeginTime: "00:00",
					Period5EndTime: "00:00",
					Period5Price: "0",
					Period5ServicePrice: "0",

					Period6BeginTime: "00:00",
					Period6EndTime: "00:00",
					Period6Price: "0",
					Period6ServicePrice: "0",

					Period7BeginTime: "00:00",
					Period7EndTime: "00:00",
					Period7Price: "0",
					Period7ServicePrice: "0",

					Period8BeginTime: "00:00",
					Period8EndTime: "00:00",
					Period8Price: "0",
					Period8ServicePrice: "0",

					Period9BeginTime: "00:00",
					Period9EndTime: "00:00",
					Period9Price: "0",
					Period9ServicePrice: "0",

					Period10BeginTime: "00:00",
					Period10EndTime: "00:00",
					Period10Price: "0",
					Period10ServicePrice: "0",

					Period11BeginTime: "00:00",
					Period11EndTime: "00:00",
					Period11Price: "0",
					Period11ServicePrice: "0",

					Period12BeginTime: "00:00",
					Period12EndTime: "00:00",
					Period12Price: "0",
					Period12ServicePrice: "0",

					
					//ServicePrice: 0,
					ModifyTime: dateFormat.formatDate(new Date(), 'yyyy-MM-dd'),
					ModifyBy: 0,
					//PriceType: 1,
					//Previous: -2
				},
				BreadcrumbList: [this.$t('Top.stationManage'), '>>', this.$t('priceTemplate')],
				formInline: {
					StationId: 0,
					//EquipmentModel: '',
					EquipmentType: 0,
					EquipmentNo: ''
				},
				//Table Title Data
				columns1: [{
						type: 'selection',
						width: 40,
						align: 'center'
					}, {
						title: this.$t('EquipmentNo'),
						key: 'ConnectorNo',
						width: 110
					},
					
					{
						title: this.$t('EquipmentType'),
						key: 'EquipmentType',
						width: 120,
						render: (h, params) => {
							return h('div', this.$options.filters.EquipmentTypeDesc(params.row.EquipmentType))
						}
					},
					{
						title: this.$t('Station'),
						key: 'StationName',
						width: 150
					},
					{
						title: this.$t('PriceManagement.TemplateName'),
						key: 'PriceTemplateName',
						width: 150
					},
					{
						title: this.$t('PriceManagement.OpUser'),
						key: 'Operator',
						width: 150
					},
					{
						title: this.$t('PriceManagement.IsSuccess'),
						key: 'Msg',
						width: 100,
						render: (h, params) => {
							let fcolor = '#ff0000';
							if (params.row.Msg == this.$t('PriceManagement.IssueSuccess')) {
								fcolor = '#55ff7f'
							}
							return h('div', {
								style: {
									color: fcolor,
								},
							}, params.row.Msg)
						}
					}, {
						title: this.$t('Common.Actions'),
						key: 'action',
						align: 'center',
						render: (h, params) => {
							let arr = [];
							arr.push(h('div', [
								this.hasWidgets('queryPrice') ? h('Button', {
									props: {
										type: 'primary',
										size: 'small'
									},
									style: {
										marginRight: '5px'
									},
									on: {
										click: () => {
											this.show("selectPrice", params.row.ConnectorNo)
										}
									}
								}, this.$t('PriceManagement.QueryPrice')) : h()
							]))
							
							return h('div', arr)
						}
					}
				],
				data1: [],
				tableSelectItems: []
			};
		},
		created() {
			const _this = this;
			// _this.tableHeight = window.innerHeight - 220;
			this.getTableHeight();
			window.addEventListener('resize', this.getTableHeight);
			_this.GetPriceModelDefine();
		},
		destroyed() {
			window.removeEventListener("resize", this.getTableHeight);
		},
		mounted() {
			this.handleSubmit();
		},
		computed: {
			pageParam: function() {
				const _this = this;
				const param = {
					StationId: _this.formInline.StationId,
					EquipmentType: _this.formInline.EquipmentType,
					//EquipmentType: _this.formInline.EquipmentType,
					EquipmentNo: _this.formInline.EquipmentNo,
					Type: 1,
				}
				return param
			},
		
			...mapState({
				StationList: 'Stations',
				PriceList: 'priceModelDefine',
				EquipmentModelDefine: 'EquipmentModelDefine'
			})
		},
		methods: {
			...mapActions([
				'GetPriceModelDefine',
			]),
			getTimezoneOffsetHours() {
        const offsetMinutes = new Date().getTimezoneOffset();
        return -offsetMinutes / 60;
    },
localTimeToUTC(localTime) {
    if(!localTime) return localTime; // 空值返回
    // 核心规则：如果是 00:00 或 24:00 → 直接返回，不转换！！！
    if(localTime === '00:00' || localTime === '24:00'){
        return localTime;
    }
    const offset = this.getTimezoneOffsetHours();
    const [hours, minutes] = localTime.split(':').map(Number);
    let utcHours = hours - offset;
    // 处理小时越界
    while (utcHours < 0) utcHours += 24;
    while (utcHours >= 24) utcHours -= 24;
    return `${String(utcHours).padStart(2, '0')}:${String(minutes).padStart(2, '0')}`;
},
// ✅ UTC 0时区时间 转 本地时间 (回显专用，同样：00:00/24:00不转换，其他正常转)
utcTimeToLocal(utcTime) {
    if(!utcTime) return utcTime; // 空值返回
    // 核心规则：如果是 00:00 或 24:00 → 直接返回，不转换！！！
    if(utcTime === '00:00' || utcTime === '24:00'){
        return utcTime;
    }
    const offset = this.getTimezoneOffsetHours();
    const [hours, minutes] = utcTime.split(':').map(Number);
    let localHours = hours + offset;
    // 处理小时越界
    while (localHours < 0) localHours += 24;
    while (localHours >= 24) localHours -= 24;
    return `${String(localHours).padStart(2, '0')}:${String(minutes).padStart(2, '0')}`;
},
			selectChange: function(a) {
				this.tableSelectItems = a.map(function(station) {
					console.log(station.ConnectorNo);
					return station.ConnectorNo;
				})
			},
			hasWidgets: function(widgetName) {
				return this.$route.meta.widgets.find(w => w.Name == widgetName);
			},
			
			show: function(type, params) {
				switch (type) {
					case "command":
						this.$Modal.confirm({
							title: this.$t('PriceManagement.SelectPriceTemplate')+'---->' + this.formInlineP.Name,
							okText: this.$t('Common.Cancel'),
							cancelText: this.$t('Common.Confirm'),
							onCancel: () => {
								this.commandBatch()
							}
						});
						break;
					case "commands_batch":
						alert(this.$t('PriceManagement.BatchIssueCommand')+"：" + this.tableSelectItems)
						break;
					case "selectPrice":
						//this.selectPriceId=params
						this.priceModal = this.$t('PriceManagement.Real-TimePrice')
						this.currentConn = params
						this.$refs.formInlineP.resetFields()
						this.QueryPrice(params)
						break;
				}
			},
		
			QueryPrice: function(ConnectorNo) {
				const _this = this
				let parms = {
					ConnectorNo: ConnectorNo,
					Type: 1
				};
				_this.$axios.post(webapi.base_api_url + "/Archives/QueryPrice", parms, {}).then(res => {
					console.log("res")
					if (res.data.Code == 0) {
						// _this.$Message.success(this.$t('PriceManagement.QueryPriceSuccess'));
						// _this.formInlineP = res.data.Data
						// _this.$Message.success(this.$t('PriceManagement.QueryPriceSuccess'));
                      // ============↓↓↓ 核心修改：赋值前做【UTC → 本地】转换 ↓↓↓============
                        let formatObj = Object.assign({}, res.data.Data);
                     // 遍历所有12个时段转换
                     for(let i=1;i<=12;i++){
                          const beginKey = `Period${i}BeginTime`;
                          const endKey = `Period${i}EndTime`;
                          if(formatObj[beginKey]){
                                  formatObj[beginKey] = this.utcTimeToLocal(formatObj[beginKey]);
                           }
                           if(formatObj[endKey]){
                                   formatObj[endKey] = this.utcTimeToLocal(formatObj[endKey]);
                           }
                     }
                      _this.formInlineP = formatObj;

					} else {
						_this.$Message.error(res.data.Msg + "---" + res.data.Data);
					}
				}).catch(error => {
					_this.$Message.error(error.data.Msg + "---" + error.data.Data);
				})
			},
			commandBatch: function() {
				const _this = this
				if (_this.tableSelectItems.length > 0 && _this.selectPriceId != '' && _this.priceModal == this.$t('Common.Search')) {
					let parms = {
						TemplateId: _this.selectPriceId,
						List: _this.tableSelectItems
					};
					_this.$axios.post(webapi.base_api_url + "/Archives/SetPriceConnector", parms, {}).then(res => {
						console.log("res")
						if (res.data.Code == 0) {
							
							res.data.Data.forEach(function(item, index) {
								_this.data1.forEach(function(item2, index2) {
									if (item.ConnectorNo == item2.ConnectorNo) {
										if (item.Code == 0) {
											item2.Msg = this.$t('PriceManagement.IssueSuccess')
											item2.PriceTemplateName = _this.formInlineP.Name
										} else {
											item2.Msg = this.$t('PriceManagement.IssueFail')
										}
										// item2.Msg = item.Msg
									}
								})
							})
							_this.tableSelectItems = []
						}
					})
				} else {
					_this.$Message.warning(this.$t('PriceManagement.PleaseSelectTemplateToissue'))
				}
			},
			getDeviceData: function(data) {
				this.data1 = data.Data.List
			},
			handleSubmit: function() {
				this.$refs.sonPage.getList();
			},
			getTableHeight: function() {
				this.tableHeight = window.innerHeight - 220 - (window.innerWidth < 1570 ? 60 : 0);
			},
			
			handleSubmitP: function(type) {
				switch (type) {
					case 'add':
						this.addPriceTemplate()
						break;
					case 'changeModalAdd':
						this.$refs.formInlineP.resetFields()
						this.priceModal =this.$t('Common.Add')
						break;
					case 'changeModalSelect':
						this.$refs.formInlineP.resetFields()
						this.priceModal = this.$t('Common.Search')
						this.showPriceModel(this.selectPriceId)
						break;
					default:
						break;
				}
			},
		
			addPriceTemplate: function() {
				const _this = this;
				_this.formInlineP.Id = 0
				let parms = _this.formInlineP;
				parms.type = 1;
				for(let i=1;i<=12;i++){
                  const beginKey = `Period${i}BeginTime`;
                  const endKey = `Period${i}EndTime`;
                if(parms[beginKey]){
                     parms[beginKey] = this.localTimeToUTC(parms[beginKey]);
                }
                if(parms[endKey]){
                   parms[endKey] = this.localTimeToUTC(parms[endKey]);
                 }
               }

				_this.$axios.post(webapi.base_api_url + "/Archives/AddPriceTemplate", parms, {}).then(res => {
					console.log("Add template")
					if (res.data.Code == 0) {
						_this.$Message.success(this.$t('PriceManagement.AddedSuccess'));
						_this.GetPriceModelDefine()
					} else {
						_this.$Message.error(this.$t('PriceManagement.AddedFail')+':' + res.data.Data);
					}
				})
			},
			showPriceModel: function(value) {
				let abj = this.PriceList.filter(function(priceModel) {
					return priceModel.Id == value
				})[0]

				let formatObj = Object.assign({}, abj);
               // 遍历所有12个时段，把BeginTime/EndTime全部转成本地时间
              for(let i=1;i<=12;i++){
                    const beginKey = `Period${i}BeginTime`;
                    const endKey = `Period${i}EndTime`;
                     if(formatObj[beginKey]){
						
                         formatObj[beginKey] = this.utcTimeToLocal(formatObj[beginKey]);
						 console.log(beginKey, formatObj[beginKey] );
                    }
                     if(formatObj[endKey]){
                     formatObj[endKey] = this.utcTimeToLocal(formatObj[endKey]);
					 console.log(endKey, formatObj[endKey] );
                   }
               }
            this.formInlineP = formatObj;

				//this.formInlineP = Object.assign({}, abj)
			}
		},
	}
</script>

<style>
	/* 	#tree{
		width: 1200px;
		height: 600px;
		margin-top: 7%;
		border: 2px solid red;
	} */

	.ivu-tag-dot {
		border: 0px solid #e8eaec !important;
	}

	.ivu-form-item {
		margin-bottom: 10px;
	}

	.ivu-col-span-7 {
		margin-left: 2%;
	}

	.demo-split {
		height: 97%;
		border: 5px solid #e2e2dc;
	}

	.demo-split-pane {
		padding: 10px;

	}
</style>
